import { Outlet } from "react-router-dom";
import { Breadcrumbs, CompressingMenu, DataGridPage } from "@synota-io/synota-shared-ui";
import { useContractLinks } from "./hooks/useContractLinks";
import { LoadingContractBlock } from "./components/LoadingContractBlock";
import { Stack } from "@mui/material";
import { ContractAdminActions } from "./components/ContractAdminActions";
import { useAuth } from "../../../api/auth/useAuth";

export const ContractDetailsOutlet = () => {
  const { isAdmin } = useAuth();
  const { menuLinks, matchedLinks, contract, isPending } = useContractLinks();

  return !contract ? (
    <LoadingContractBlock isLoading={isPending} />
  ) : (
    <DataGridPage
      disablePaper
      actions={(maxWidth) => {
        return <CompressingMenu primaryActions={menuLinks} maxWidth={maxWidth} />;
      }}
      title={
        <Stack
          direction={{ xs: "column", md: "row" }}
          alignItems={{ xs: "flex-start", md: "center" }}
          gap={4}
        >
          <Breadcrumbs links={matchedLinks} />
          {isAdmin ? <ContractAdminActions /> : null}
        </Stack>
      }
    >
      <Outlet />
    </DataGridPage>
  );
};
